import { NotificationActionTypes, UPDATE_MARK_CONVERSATION_AS_READ, UPDATE_NOTIFICATIONS, UPDATE_UNREAD_NOTIFICATION_ITEMS_COUNT, UpdateNotificationListAction } from "./notificationActionAndReducerTypes";
import { NotificationListState, UpdateMarkConversationAsReadActionPayload, UpdateNotificationsActionPayload, UpdateUnreadNotificationItemsCountActionPayload } from "./rootReducerTypes";


export function updateNotifications(updateNotificationsActionPayload: UpdateNotificationsActionPayload): UpdateNotificationListAction {
    return {
        type: UPDATE_NOTIFICATIONS,
        updateNotificationsActionPayload,
    };
}

export function updateUnreadNotificationItemsCount(updateUnreadNotificationItemsCountActionPayload: UpdateUnreadNotificationItemsCountActionPayload) {
    return {
        type: UPDATE_UNREAD_NOTIFICATION_ITEMS_COUNT,
        updateUnreadNotificationItemsCountActionPayload
    };
}

export function markConversationAsRead(updateMarkConversationAsReadActionPayload: UpdateMarkConversationAsReadActionPayload) {
    return {
        type: UPDATE_MARK_CONVERSATION_AS_READ,
        updateMarkConversationAsReadActionPayload
    };
}

export default function notificationListReducer(state: NotificationListState = initialState, action: NotificationActionTypes): NotificationListState {        
    switch (action.type) {
        case 'UPDATE_NOTIFICATIONS':
            return {
                ...state,
                notifications: action.updateNotificationsActionPayload.notifications
            };
        case 'UPDATE_UNREAD_NOTIFICATION_ITEMS_COUNT':
            return {
                ...state,
                unreadItems: action.updateUnreadNotificationItemsCountActionPayload.unreadItems
            };
        case 'UPDATE_MARK_CONVERSATION_AS_READ':
            const conversationId = action.updateMarkConversationAsReadActionPayload.notificationId;
            const updatedNotifications = state.notifications.filter(notification => notification.id !== conversationId);

            return {
                ...state,
                notifications: updatedNotifications
            };
        default:
            return state;
    }
}

export const initialState: NotificationListState = {
    notifications: [],
    unreadItems: 0
};